module.exports = __webpack_public_path__ + "static/media/S (151).5b61490f.jpg";